const convertObjectToURLParams = (obj: Record<string, unknown>): string => {
  const params = Object.entries(obj)
    .filter(([, value]) => value !== undefined && value !== null)
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`);

  return params.length > 0 ? `?${params.join('&')}` : '';
};

export const SOCIAL_TYPE = {
  FACEBOOK: 'facebook',
  TWITTER: 'twitter',
  LINKEDIN: 'linkedin',
  TELEGRAM: 'telegram',
  WHATSAPP: 'whatsapp',
  REDDIT: 'reddit',
  EMAIL: 'email',
} as const;

export type SocialTypeName = keyof typeof SOCIAL_TYPE;

export type SocialType = (typeof SOCIAL_TYPE)[SocialTypeName];

const formatTextWithUrl = (url = '', text = '', placeholder = '{{url}}') => {
  if (text.includes(placeholder)) {
    return text.replace(placeholder, url);
  }

  return text ? `${text} ${url}` : url;
};

export interface SocialShareConfig {
  url: string;
  title?: string;
  text?: string;

  /**
   * NOTE: for twitter only
   */
  via?: string;
}

export const getShareUrl = (social: SocialType, { text, url, title, via }: SocialShareConfig) => {
  const formattedText = formatTextWithUrl(url, text);

  switch (social) {
    case SOCIAL_TYPE.EMAIL:
      return `mailto:${convertObjectToURLParams({ subject: title, body: formattedText })}`;

    case SOCIAL_TYPE.FACEBOOK:
      // NOTE: facebook doesn't support next params anymore
      // quote: title,
      return `https://www.facebook.com/sharer/sharer.php${convertObjectToURLParams({ u: url })}`;

    case SOCIAL_TYPE.WHATSAPP:
      return `https://api.whatsapp.com/send${convertObjectToURLParams({ text: formattedText })}`;

    case SOCIAL_TYPE.LINKEDIN:
      return `https://www.linkedin.com/sharing/share-offsite${convertObjectToURLParams({ url })}`;

    // NOTE: 1. without url param share url will not work
    // NOTE: 2. url can be used as title
    case SOCIAL_TYPE.TELEGRAM:
      return `https://t.me/share/url${convertObjectToURLParams({ text: formattedText, url })}`;

    // NOTE: twitter adding url at the end of the text before `via` separating it with space
    case SOCIAL_TYPE.TWITTER:
      return `https://twitter.com/share${convertObjectToURLParams({ text: formattedText, via })}`;

    case SOCIAL_TYPE.REDDIT:
      return `https://www.reddit.com/submit${convertObjectToURLParams({
        url,
        text: formatTextWithUrl,
        title,
      })}`;
  }

  return '';
};
